import { useState } from "react";
import { useLoginForm } from "../hooks/useLoginForm";
import Button from '../../../components/Button';
import { formFieldClass, formShell } from '../../../styles/formShell';
import { pageShell } from '../../../styles/pageShell';
import { typeShell } from '../../../styles/typeShell';

/** Login layout only — field look comes from formShell.
 * Title uses pageShell.titleText (page title role); layout padding is local. */
const loginShell = {
    form:
        "mt-4 flex w-[95%] flex-col rounded-lg p-4 bp-lg:mt-10 bp-lg:w-[85%] bp-lg:max-w-[35rem] bp-lg:rounded-2xl bp-lg:p-8 bp-xl:mt-11 bp-xl:p-9 bp-2xl:mt-12 bp-2xl:w-4/5 bp-2xl:max-w-[40rem] bp-2xl:rounded-[1.25rem] bp-2xl:p-10",
    title: `${pageShell.titleText} mb-4 text-center leading-[1.3] bp-lg:mb-8 bp-lg:leading-[1.4]`,
    field: "mb-3 bp-lg:mb-6",
    fieldLast: "mb-4 bp-lg:mb-8",
    passwordWrap: "relative",
    passwordInput: "pr-10",
    passwordToggle:
        `absolute right-2 top-1/2 inline-flex h-8 -translate-y-1/2 items-center justify-center border-none bg-transparent p-1 bp-lg:right-3 bp-lg:p-1.5 ${typeShell.hint}`,
    message: `${formShell.error} mb-1.5 flex min-h-10 items-center font-bold bp-lg:mb-2 bp-lg:min-h-[2.875rem] bp-xl:mb-2.5 bp-2xl:mb-3`,
    messageEmpty: "invisible",
    submit: "mb-1.5 bp-lg:mb-3",
};

function LoginForm() {
    const { state, actions } = useLoginForm();
    const { form, msg, isSubmitting } = state;
    const { handleChange, handleSubmit } = actions;
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <form onSubmit={handleSubmit} className={loginShell.form}>
            <h2 className={loginShell.title}>サインイン</h2>

            <div className={`${formShell.group} ${loginShell.field}`}>
                <label htmlFor="login_id" className={formShell.label}>ログイン ID</label>
                <input
                    id="login_id"
                    name="login_id"
                    type="text"
                    value={form.login_id}
                    onChange={handleChange}
                    placeholder="例: user1"
                    autoComplete="username"
                    className={formFieldClass(false)}
                />
            </div>

            <div className={`${formShell.group} ${loginShell.fieldLast}`}>
                <label htmlFor="password" className={formShell.label}>パスワード</label>
                <div className={loginShell.passwordWrap}>
                    <input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        value={form.password}
                        onChange={handleChange}
                        placeholder="例: password"
                        autoComplete="current-password"
                        className={`${formFieldClass(false)} ${loginShell.passwordInput}`}
                    />
                    <button
                        type="button"
                        className={loginShell.passwordToggle}
                        onClick={togglePasswordVisibility}
                        aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示"}
                    >
                        <span className="material-symbols-outlined">
                            {showPassword ? "visibility_off" : "visibility"}
                        </span>
                    </button>
                </div>
            </div>

            <span
                className={`${loginShell.message} ${msg ? '' : loginShell.messageEmpty}`}
            >
                {msg || ''}
            </span>

            <Button
                type="submit"
                variant="primary"
                size="cta"
                disabled={isSubmitting}
                className={loginShell.submit}
            >
                {isSubmitting ? "ログイン中..." : "ログイン"}
            </Button>
        </form>
    );
}

export default LoginForm;
